
<script setup>

  import { ref } from 'vue';

  import { useRouter } from 'vue-router';

  import { v4 as uuidv4 } from 'uuid';

  import { ArrowDownTrayIcon, ArrowLeftCircleIcon, ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

  import { selections, hasDownloaded } from '../stores/activity-4.js';

  import { exportPDF } from '../pdfs/activity-4.js';

  import backgroundPath from '../images/distressed-background.jpg';

  const router = useRouter();

  if ( selections.value < 3 ) router.replace( { path: '/activity/4/part/1' } );
  
  const firstNameId = uuidv4();

  const firstNameValue = ref( null );

  const lastNameId = uuidv4();

  const lastNameValue = ref( null );

  function download() {

    exportPDF( firstNameValue.value, lastNameValue.value );

    hasDownloaded.value = true;

  }

</script>

<template>

  <article>

    <div class="grid items-center justify-center min-h-view bg-fixed bg-cover bg-center" :style="{ backgroundImage: `url( ${ backgroundPath } )` }">

      <div class="p-6 md:p-12 lg:p-24">

        <div class="max-w-xl">

          <h2 class="pb-6 border-b-[3px] border-black">

            <div class="text-xl tracking-narrow font-semibold uppercase">Activity 4</div>

            <div class="text-4xl md:text-5xl font-heading uppercase">Review &amp; Download</div>

          </h2>

          <h3 class="mt-8 text-2xl md:text-3xl font-medium font-serif italic">Review Your Work</h3>

          <p class="mt-3 leading-7 text-neutral-700">

            You've completed this activity. If you want you can use the 'Back'
            
            button at the bottom of this page to go back and review what
            
            you've written.

          </p>

        </div>

        <div class="max-w-xl mt-8 p-8 bg-white border border-neutral-300 shadow-sm">

          <h3 class="font-heading text-3xl">Download Your Activity File</h3>

          <p class="mt-3 leading-7 text-neutral-700">

            When you're ready, enter your name below and download your Activity 4 file

            to send to your instructor. This file can be printed, emailed, or uploaded to

            your classroom software.

          </p>

          <div class="mt-4">

            <label class="text-sm font-bold" :for="firstNameId">
              
              First Name <span class="text-sm text-red-600">*</span>
            
            </label>

            <input
            
              class="block w-full mt-2 border-0 py-1.5 text-neutral-900 shadow-sm ring-1 ring-inset ring-neutral-300
          
                placeholder:text-neutral-400 focus:ring-2 focus:ring-inset focus:ring-lime-800 sm:text-sm sm:leading-6"
          
              :id="firstNameId" type="text" v-model="firstNameValue" />

          </div>

          <div class="mt-4">

            <label class="text-sm font-bold" :for="lastNameId">
              
              Last Name <span class="text-sm text-red-600">*</span>
            
            </label>

            <input

              class="block w-full mt-2 border-0 py-1.5 text-neutral-900 shadow-sm ring-1 ring-inset ring-neutral-300

                placeholder:text-neutral-400 focus:ring-2 focus:ring-inset focus:ring-lime-800 sm:text-sm sm:leading-6"

              :id="lastNameId" type="text" v-model="lastNameValue" />

          </div>

          <button
          
            type="button"
            
            class="flex items-center gap-4 px-6 py-4 mt-12 ml-auto text-white font-bold text-white bg-green-700 transition-colors
            
              hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline disabled:bg-neutral-500"
          
            @click="download" :disabled="! ( firstNameValue && lastNameValue )">

            <span>Download</span>

            <ArrowDownTrayIcon class="w-6" />
          
          </button>

        </div>

        <div class="flex justify-between gap-6 mt-12">

          <RouterLink
          
            class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-neutral-600 transition-colors
                
              hover:bg-neutral-700 focus-visible:bg-neutral-700 hover:underline focus-visible:underline"
          
            to="/activity/4/part/2/exercise/3">
            
            <ArrowLeftCircleIcon class="w-8" />

            <span>Back</span>
          
          </RouterLink>

          <button
          
            class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-green-700 transition-colors
            
              hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline disabled:bg-neutral-500"
          
            @click="router.push( '/activity/4/completed' )"
            
            :disabled="! hasDownloaded">
            
            <span>Finish</span>

            <ArrowRightCircleIcon class="w-8" />
          
          </button>

        </div>

      </div>

    </div>

  </article>

</template>
